import { useFormEngineElement } from '@form-engine/core-application/hooks/use-element';
import FormCheckList from './form-check-list';
import NestedFormCheckList from './nested-form-check-list/index';

export const apiName = 'FormEngineCheckboxElement' as const;

export default Object.assign(
    function FormEngineCheckboxElement() {
        const { state: element } = useFormEngineElement();
        if (!element || element.type !== apiName)
            throw new Error('tried to render checkbox with invalid definition');

        const { state } = useFormEngineElement();

        if (state?.nested) {
            return <NestedFormCheckList />;
        }

        return <FormCheckList />;
    },
    { apiName, isField: true, enabled: true }
);
